import reducer from "./reducer";
export { default as GoalsAndObjectives } from "./components/index";
export { default as goalsAndObjectivesReducerName } from "./constants";
export default reducer;
